import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
// PHP API: BASE already includes full path (e.g. https://shiatunes.com/api/v2)
// FastAPI: BASE is root (e.g. https://st-2z7y.onrender.com) — append /api
export const API = BASE.includes('/api') ? BASE : `${BASE}/api`;

// Local uploads ka full URL banao
export function resolveMediaUrl(url) {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/uploads/")) return `${BASE}${url}`;
  return url;
}

const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("st_token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

export default http;

// Public endpoints
export const fetchCategories = () => http.get("/categories").then((r) => r.data);
export const fetchReciters = () => http.get("/reciters").then((r) => r.data);
export const fetchTracks = (params) => http.get("/tracks", { params }).then((r) => r.data);
export const fetchTrack = (id) => http.get(`/tracks/${id}`).then((r) => r.data);
export const fetchAlbums = (params) => http.get("/albums", { params }).then((r) => r.data);
export const fetchAlbum = (id) => http.get(`/albums/${id}`).then((r) => r.data);
export const fetchArticles = (params) => http.get("/articles", { params }).then((r) => r.data);
export const fetchArticle = (slug) => http.get(`/articles/${slug}`).then((r) => r.data);
export const fetchLiveStreams = () => http.get("/livestreams").then((r) => r.data);
export const fetchActiveLive = () => http.get("/livestreams/active").then((r) => r.data);
export const fetchAgoraToken = (channel, uid = 0, role = 2) =>
  http.get("/agora/token", { params: { channel, uid, role } }).then((r) => r.data);
export const search = (q) => http.get("/search", { params: { q } }).then((r) => r.data);

// Admin
export const seedData = () => http.post("/seed").then((r) => r.data);
export const syncUploads = () => http.post("/sync-uploads").then((r) => r.data);
export const importSupabase = () => http.post("/import-supabase").then((r) => r.data);
export const createCategory = (d) => http.post("/categories", d).then((r) => r.data);
export const deleteCategory = (id) => http.delete(`/categories/${id}`).then((r) => r.data);
export const createReciter = (d) => http.post("/reciters", d).then((r) => r.data);
export const deleteReciter = (id) => http.delete(`/reciters/${id}`).then((r) => r.data);
export const createAlbum = (d) => http.post("/albums", d).then((r) => r.data);
export const deleteAlbum = (id) => http.delete(`/albums/${id}`).then((r) => r.data);
export const createTrack = (d) => http.post("/tracks", d).then((r) => r.data);
export const deleteTrack = (id) => http.delete(`/tracks/${id}`).then((r) => r.data);
export const createArticle = (d) => http.post("/articles", d).then((r) => r.data);
export const deleteArticle = (id) => http.delete(`/articles/${id}`).then((r) => r.data);
// Users (admin only)
export const fetchUsers = () => http.get("/users").then((r) => r.data);
export const createUser = (d) => http.post("/users", d).then((r) => r.data);
export const updateUserRole = (id, role) => http.put(`/users/${id}/role`, { role }).then((r) => r.data);
export const toggleUserStatus = (id) => http.patch(`/users/${id}/status`).then((r) => r.data);
export const deleteUser = (id) => http.delete(`/users/${id}`).then((r) => r.data);

export const createLiveStream = (d) => http.post("/livestreams", d).then((r) => r.data);
export const startLiveStream = (id) => http.post(`/livestreams/${id}/start`).then((r) => r.data);
export const stopLiveStream = (id) => http.post(`/livestreams/${id}/stop`).then((r) => r.data);
export const deleteLiveStream = (id) => http.delete(`/livestreams/${id}`).then((r) => r.data);
